export default {
  async snooze(time = 3000) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, time);
    });
  },
}